const Success = () => {
  return (
    <>
      <h1>Hurray...</h1>
      <p>Your Order is on the Way</p>
    </>
  );
};

export default Success;
